import { usePlanIsUnchangeable as useIsUnchangeable } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-unchangeable/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanIsUnchangeable = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isUnchangeable } = viewModel;

	return useIsUnchangeable({ isUnchangeable, onSetViewModel });
};
